import React from "react";
import visionImg from "../../assets/images/martech-menu.webp";
import missionImg from "../../assets/images/Enterprise-SEO-1.webp";

function Aboutsection() {
  const stats = [
    {
      number: " Initial consultation",
      text: "We started listening. Understanding your goals, challenges, schedules and budget is the basis of our process.",
      color: "#7BC043",
    },
    {
      number: "Planning and Design",
      text: "We have prepared detailed itineraries, wireframes and models. You are involved in every step, ensuring that the design corresponds to your vision.",
      color: "#333333",
    },
    {
      number: "Development and Execution",
      text: "Our developers bring to life to clean, scalable and high performance code. Strict testing ensures that everything works perfectly.",
      color: "#008080",
    },

    {
      number: "Launch & Monitoring",
      text: "After launch, we track performance using analytics, making data-driven improvements wherever needed.",
      color: "#008080",
    },

    {
      number: "Ongoing Growth",
      text: "Post-launch, we remain your partners  providing maintenance, updates, and marketing support to help you scale.",
      color: "#7BC043",
    },
  ];

  return (
    <>
      <section className="about-section-one">
        <div className="about-container">
          <div className="about-left">
            <h2>Who We Are at Empower Web</h2>
          </div>
          <div className="about-right">
            <p>
              Empower Web is a effects-driven web development company near me in India, dedicated to assisting businesses grow within the
              digital international. We concentrate on developing
              excessive-overall performance websites, powerful SEO strategies,
              and statistics-driven virtual advertising answers that deliver
              actual consequences.
            </p><br />
            <p>
              With a crew of skilled builders, designers, and entrepreneurs,
              Empower Web specializes in building user-friendly, speedy, and
              SEO-optimized web sites tailor-made to your commercial enterprise
              dreams. Whether you are a startup seeking to set up your on-line
              presence or a longtime commercial enterprise aiming to scale, we
              provide customized solutions that force site visitors, generate
              leads, and increase conversions. At Empower Web, we consider in
              innovation, transparency, and lengthy-term partnerships. Our
              technique is straightforward understand your enterprise, create
              effective techniques, and deliver measurable growth. Over the
              years, we've got helped a couple of companies throughout
              industries achieve achievement via clever virtual answers.
            </p>
          </div>
        </div>
      </section>
      
      <div className="about-section">
        <div className="about-mission">
          <h2>Vision & Mission</h2>
          <div className="mission-item">
            <div className="our-vision">
              <img src={visionImg} alt="vision" />
              <h3>Our Vision</h3>
              <p>
                At Empower Web, we envision a digitally empowered future where
                every business, regardless of size or budget, can harness the
                full potential of the online world.
              </p>
            </div>
            <div className="our-vision">
              <img src={missionImg} alt="mission" />
              <h3>Our Mission</h3>
              <p>
                Our mission is to deliver personalized digital solutions
                tailored to the unique needs of every business.
              </p>
            </div>
          </div>
        </div>
        <section className="values-section">
          <h2 className="values-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="values-card-1">
              <h3>Integrity</h3>
              <p>Honesty and transparency in all steps.</p>
            </div>
            <div className="values-card-2">
              <h3>Dedication</h3>
              <p>100% commitment to all customer projects.</p>
            </div>
            <div className="values-card-1">
              <h3>Collaboration</h3>
              <p>Working as your partner, not just a supplier.</p>
            </div>
            <div className="values-card-2">
              <h3>Quality</h3>
              <p>Providing solutions that exceed expectations.</p>
            </div>
            <div className="values-card-1">
              <h3>Creativity and Innovation</h3>
              <p>Bringing new ideas to everything we do.</p>
            </div>
            <div className="values-card-2">
              <h3>Customer Growth</h3>
              <p>We add the multiplier effect to customers’ businesses.</p>
            </div>
            <div className="values-card-1">
              <h3>Open mind. Open door</h3>
              <p>
                We explore possibilities; we don’t say no right away. We’re
                flexible and transparent.
              </p>
            </div>
            <div className="values-card-2">
              <h3>Keep Learning. Keep Unlearning</h3>
              <p>
                We let go of the old and adapt to the latest trends and
                technologies.
              </p>
            </div>
            <div className="values-card-1">
              <h3>Think Big. Be Bold</h3>
              <p>
                We’re not afraid to set our sights really high. Impossible is
                nothing!
              </p>
            </div>
          </div>
        </section>
        <div className="clients-process-container">
          <section className="clients-section">
            <h2>Our work process</h2>
            <p>
              At Empower Web, our work process is designed to deliver seamless
              digital solutions. We begin with a thorough initial consultation,
              understanding your goals, challenges, and timelines. 
            </p>
            <br />
            <div className="stats-circles">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="stat-circle"
                  style={{ backgroundColor: stat.color }}
                >
                  <h3>{stat.number}</h3>
                  <p>{stat.text}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
      
    </>
  );
}

export default Aboutsection;
